export const EXISTING_CUSTOMER = "EXISTING_CUSTOMER";
export const EXISTING_CUSTOMER_SIGN_IN = "EXISTING_CUSTOMER_SIGN_IN";
export const EXISTING_CUSTOMER_SSO_ENROLL = "EXISTING_CUSTOMER_SSO_ENROLL";
export const EXISTING_CUSTOMER_BLOCK = "EXISTING_CUSTOMER_BLOCK";
export const NEW_CUSTOMER = "NEW_CUSTOMER";
